import styled from "styled-components";
import { InfoCircleOutlined } from "@ant-design/icons";
import { TEAL } from "../../EmployeeSkillsBridgerV2.constants";
import { SB_COLORS } from "theme/SbThemeV2";

// ─── Modal title row ──────────────────────────────────────────────────────────

export const ScaleModalTitleStyled = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ScaleInfoIconStyled = styled(InfoCircleOutlined)`
  color: ${TEAL};
  font-size: 18px;
`;

// ─── List item avatar ─────────────────────────────────────────────────────────

export const ScaleAvatarStyled = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${TEAL};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 13px;
  flex-shrink: 0;
`;

// ─── Antd Modal style config objects ─────────────────────────────────────────
// These are passed directly to antd Modal `styles` prop, not CSS-in-JS.

export const SCALE_DETAILS_MODAL_STYLES = {
  header: {
    backgroundColor: SB_COLORS.secondary,
    padding: "16px 24px",
    margin: "-20px -24px 0",
    borderRadius: "8px 8px 0 0",
  },
  body: { maxHeight: "60vh", overflowY: "auto", paddingTop: 16 },
};
